<template>
  <div id="app">
    <Navbar style="z-index:1000;"/>
    <router-view class="mt-5 pt-3"/>
  </div>
</template>

<script>
import Navbar from "./components/tools/Navbar";
export default {
  components: {
    Navbar
  }
};
</script>

<style>
.v-toolbar {
  position: fixed !important;
  top: 0;
  left: 0;
}
</style>

 